import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  constructor() {
    this.initIconRegistry();
  }

  private initIconRegistry() {
    const iconDictionary: Record<string, string> = {
      'account-box': 'account box.svg',
      'account-circle': 'account circle.svg',
      'account-tree': 'account tree.svg',
      add: 'add.svg',
      'add-circle': 'add circle.svg',
      'add-doc': 'add doc.svg',
      'add-triangle': 'add triangle.svg',
      'admin-settings': 'admin settings.svg',
      'amex-small': 'payment-method/amex-16.svg',
      'amex-medium': 'payment-method/amex-24.svg',
      'amex-large': 'payment-method/amex-48.svg',
      'applepay-small': 'payment-method/applepay-16.svg',
      'applepay-medium': 'payment-method/applepay-24.svg',
      'applepay-large': 'payment-method/applepay-48.svg',
      archive: 'archive.svg',
      'arrow-downward': 'arrow_downward.svg',
      'arrow-upward': 'arrow_upward.svg',
      assignment: 'assignment.svg',
      badge: 'badge.svg',
      ballot: 'ballot.svg',
      'bar-chart': 'bar chart.svg',
      blank: 'blank.svg',
      block: 'block.svg',
      book: 'book.svg',
      'bookmark-save': 'bookmark save.svg',
      calendar: 'calendar.svg',
      'cancel-circle': 'cancel circle.svg',
      cards: 'cards.svg',
      category: 'category.svg',
      'chart-arrow': 'chart arrow.svg',
      check: 'check.svg',
      'check-circle': 'check circle.svg',
      checkbook: 'checkbook.svg',
      checklist: 'checklist.svg',
      'checklist-alt': 'checklist-1.svg',
      'chevron-down': 'chevron down.svg',
      'chevron-left': 'chevron left.svg',
      'chevron-right': 'chevron right.svg',
      'chevron-up': 'chevron up.svg',
      'clipboard-empty': 'clipboard Empty.svg',
      'clipboard-full': 'clipboard Full.svg',
      clock: 'clock.svg',
      close: 'close.svg',
      'cloud-done': 'cloud done.svg',
      'cloud-download': 'cloud download.svg',
      'collapse-all': 'collapse all.svg',
      'content-copy': 'content copy.svg',
      contract: 'contract.svg',
      dashboard: 'dashboard.svg',
      'data-table': 'data table.svg',
      deadline: 'deadline.svg',
      delete: 'delete.svg',
      'delete-alt': 'delete-1.svg',
      description: 'description.svg',
      difference: 'difference.svg',
      'discover-small': 'payment-method/discover-16.svg',
      'discover-medium': 'payment-method/discover-24.svg',
      'discover-large': 'payment-method/discover-48.svg',
      distance: 'distance.svg',
      dollar: 'dollar.svg',
      download: 'download.svg',
      download2: 'download2.svg',
      draft: 'draft.svg',
      drag: 'drag.svg',
      'edit-calendar': 'edit calendar.svg',
      'edit-doc': 'edit doc.svg',
      'edit-square': 'edit square.svg',
      email: 'email.svg',
      error: 'error.svg',
      'expand-all': 'expand all.svg',
      'expand-content': 'expand_content.svg',
      facilities: 'facilities.svg',
      championship: 'championship.svg',
      favorite: 'favorite.svg',
      'file-copy': 'file copy.svg',
      'file-export': 'file export.svg',
      'file-present': 'file present.svg',
      filter: 'filter.svg',
      'googlepay-small': 'payment-method/googlepay-16.svg',
      'googlepay-medium': 'payment-method/googlepay-24.svg',
      'googlepay-large': 'payment-method/googlepay-48.svg',
      'graph-arrow': 'graph arrow.svg',
      group: 'group.svg',
      'group-add': 'group add.svg',
      'group-search': 'group search.svg',
      history: 'history.svg',
      home: 'home.svg',
      hotel: 'hotel.svg',
      hourglass: 'hourglass.svg',
      'id-card': 'id card.svg',
      info: 'info.svg',
      'interac-small': 'payment-method/interac-16.svg',
      'interac-medium': 'payment-method/interac-24.svg',
      'interac-large': 'payment-method/interac-48.svg',
      laptop: 'laptop.svg',
      list: 'list.svg',
      loading: 'loading.svg',
      location: 'location.svg',
      map: 'map.svg',
      'mastercard-small': 'payment-method/mastercard-16.svg',
      'mastercard-medium': 'payment-method/mastercard-24.svg',
      'mastercard-large': 'payment-method/mastercard-48.svg',
      menu: 'menu.svg',
      'menu-large': 'menu large.svg',
      minus: 'minus.svg',
      'more-horizontal': 'more horizontal.svg',
      'more-vertical': 'more vertical.svg',
      multiple: 'multiple.svg',
      'new-window': 'new window.svg',
      notifications: 'notifications.svg',
      'notifications-active': 'notifications active.svg',
      office: 'office.svg',
      'paypal-small': 'payment-method/paypal-16.svg',
      'paypal-medium': 'payment-method/paypal-24.svg',
      'paypal-large': 'payment-method/paypal-48.svg',
      pen: 'pen.svg',
      percent: 'percent.svg',
      person: 'person.svg',
      'play-circle': 'play_circle.svg',
      print: 'print.svg',
      'privacy-tip': 'privacy tip.svg',
      publish: 'publish.svg',
      question: 'question.svg',
      receipt: 'receipt.svg',
      report: 'report.svg',
      school: 'school.svg',
      search: 'search.svg',
      send: 'send.svg',
      settings: 'settings.svg',
      'settings-alert': 'settings alert.svg',
      shop: 'shop.svg',
      'stop-watch': 'stop watch.svg',
      table: 'table.svg',
      'table-alt': 'table-1.svg',
      ticket: 'ticket.svg',
      torus: 'torus.svg',
      'tree-chart': 'tree chart.svg',
      unchecked: 'unchecked.svg',
      upload: 'upload.svg',
      'user-attributes': 'user attributes.svg',
      'user-settings': 'user settings.svg',
      view: 'view.svg',
      'visa-small': 'payment-method/visa-16.svg',
      'visa-medium': 'payment-method/visa-24.svg',
      'visa-large': 'payment-method/visa-48.svg',
      visibility: 'visibility.svg',
      'visibility-off': 'visibility off.svg',
      'waitlist-conversion': 'waitlist conversion.svg',
      warning: 'warning.svg',
      work: 'work.svg',
      'work-alt': 'work 2.svg',
    };

    for (const iconName of Object.keys(iconDictionary)) {
      const fileName = iconDictionary[iconName];
      this.matIconRegistry.addSvgIcon(
        iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/shared-lib/icons/${fileName}`),
      );
    }
  }
}
